/* eslint-disable */
import Events from "@/events";
import { RXJSCache } from "@/data-services/cache/rxjs-cache";
import { getConfigBasic } from "@/api/common";

class ConfigBasicService {
  constructor(rootVue) {
    this._configCache = new RXJSCache({
      func: getConfigBasic,
      events: [
        // driver
        Events.NEW_DRIVER,
        Events.EDIT_DRIVER,
        Events.DELETE_DRIVER,
        // load
        Events.NEW_LOADS,
        Events.EDIT_LOADS,
        Events.DELETE_LOADS,
        // document
        Events.NEW_DOCUMENT,
        Events.EDIT_DOCUMENT,
        Events.DELETE_DOCUMENT,
        // expense
        Events.NEW_EXPENSE,
        Events.EDIT_EXPENSE,
        Events.DELETE_EXPENSE,
      ],
      cacheCount: 10,
      formatResult: true,
      name: "configBasicServiceList",
      // itemCache: true,
      // getKeyFromEvent: (data) => data,
      // getKeyFromArgs: params => params,
      $bus: rootVue,
    });
  }
  get list() {
    return this._configCache;
  }
}

let instance = null;

export function configBasicServiceInit($bus) {
  console.debug("configBasicServiceInit");
  if (!instance) {
    instance = new ConfigBasicService($bus);
  }
}

export function getConfigBasicServiceInstance() {
  return instance;
}
